import { Grid } from "@mui/material";
import { Profile } from "@readyfit-common/models";
import { OrganizationRecruitmentProcess } from "src/store/reducers/organizations/organizationsApiSlice";
import useStyles from "../AthleteDetails.styles";
import RecruitmentProcessWidget from "../RecruitmentProcessWidget/RecruitmentProcessWidget";

const RecruitmentProcessCard = ({
  athlete,
  organizationRecruitmentProcess,
}: {
  athlete: Profile | null;
  organizationRecruitmentProcess: OrganizationRecruitmentProcess | null;
}) => {
  const classes = useStyles();
  return athlete?.recruitmentProcess && organizationRecruitmentProcess ? (
    <Grid
      container
      marginTop={3}
      className={classes.recruitmentProcessContainer}
    >
      <RecruitmentProcessWidget
        recruitmentProcess={athlete.recruitmentProcess}
        organizationRecruitmentProcess={organizationRecruitmentProcess}
      />
    </Grid>
  ) : null;
};

export default RecruitmentProcessCard;
